import * as React from "react";
import "@frameworks/shared-library/stylesheets/components/error_msg.scss";
var Errormsg = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "error-msg" },
            React.createElement("div", { className: "error-msg-wrapper" },
                React.createElement("div", null,
                    React.createElement("span", { className: "erroricon  ".concat(props.icon ? props.icon : "edel-icon-error-msg-icon") })),
                React.createElement("div", { className: "error-msg-text" }, props.msg ? (React.createElement("span", { dangerouslySetInnerHTML: { __html: props.msg } })) : ("We ran in to some technical difficulties  please click refresh and try again")),
                props.refresh === true && (React.createElement("div", { className: "refreshErrorBtn" },
                    React.createElement("button", { className: "btn d-flex align-items-center", onClick: function () { return props.refreshFunc(); } },
                        React.createElement("div", { className: "refreshErrorBtn-icon" },
                            React.createElement("i", { className: "d-flex edel-icon-double-refresh" })),
                        React.createElement("p", null, "Refresh"))))))));
};
export default Errormsg;
